'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';
import { ServiceBadge } from '../service-badge/service-badge';

export const MemberBadge = ({ className = '' }) => {
    return (
        <ServiceBadge
            className={cn('tw-gap-[10px]  tw-bg-[#0050C4] tw-inline-flex tw-items-center tw-text-white ', className)}
        >
            <span className='tw-font-[700]'>BCAA Member</span>
        </ServiceBadge>
    );
};

MemberBadge.propTypes = {
    className: PropTypes.string
};
